var path = 'app/scripts/modules/kubernetes/src/securityGroup/configure/wizard/advancedSettings.html';
var html = "<form class=\"container-fluid form-horizontal\" name=\"advancedSettings\">\n  <div class=\"col-md-12\">\n    <map-editor model=\"securityGroup.annotations\" label=\"Annotations\" add-button-label=\"Add Annotations\" labels-left=\"true\"></map-editor>\n  </div>\n  <div class=\"col-md-12\">\n    <map-editor model=\"securityGroup.labels\" label=\"Labels\" add-button-label=\"Add Labels\" labels-left=\"true\"></map-editor>\n  </div>\n</form>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/kubernetes/src/securityGroup/configure/wizard/advancedSettings.html
// module id = 1507
// module chunks = 0